/** The Groups workspace's paths (jorigin/brewauth#29 GB1). */
export const GROUPS_PATH = '/groups';

/** `/groups/<id>`, with the id encoded as one path segment. */
export function groupPath(id: string): string {
  return `${GROUPS_PATH}/${encodeURIComponent(id)}`;
}

/** Whether `pathname` is the workspace: `/groups` or a group under it. */
export function isGroupsPath(pathname: string): boolean {
  return pathname === GROUPS_PATH || pathname.startsWith(`${GROUPS_PATH}/`);
}

/**
 * The query string a link to another group carries (GB7 fix round 1): the
 * workspace's own (`scope=all`, …) when it is followed from inside the
 * workspace, and none from anywhere else. The pane also runs in the
 * sharing dialog's modal, over a model page, whose query string means
 * nothing to `/groups` (and whose `scope=all` would switch an
 * administrator's list).
 */
export function groupLinkSearch(location: { pathname: string; search: string }): string {
  return isGroupsPath(location.pathname) ? location.search : '';
}
